import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useSubCategoryList() {
    const tableColumns = [
        // { key: 'cover_image', label: 'cover image', sortable: false, tdClass:'width-200 p-1' },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ];
    const isSubCategoryFormSidebarActive = ref(false)
    const subCategoryData = ref(null);
    const toast = useToast()
    const searchQuery = ref('')
    const statusFilter = ref(null)
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const foodSubCategories = ref([])
    const totalfoodSubCategories = ref(0)
    const refSubCategoryListTable = ref(null)
    const currentPage = ref(1)
    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const dataMeta = computed(() => {
        const localItemsCount = refSubCategoryListTable.value ? refSubCategoryListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalfoodSubCategories.value,
        }
    })

    const refetchSubCategoryData = () => {
        refSubCategoryListTable.value.refresh()
        fetchSubCategoryData();
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchSubCategoryData()
    })

    const fetchSubCategoryData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);
        const getLocalSite = JSON.parse(localStorage.getItem('site'))

        store
            .dispatch('app-food/getSubCategoryData', {
                limit: perPage.value,
                offset: offset,
                keywords: searchQuery.value,
                sites_id: getLocalSite.id
            })
            .then(response => {
                foodSubCategories.value = response.data.data || []
                totalfoodSubCategories.value = response.data.total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching Sub Category' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveSubCategoryStatusVariant = status => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveSubCategoryStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const updateSubCategory = (data) => {
        subCategoryData.value = data
        isSubCategoryFormSidebarActive.value = true
    }

    const deleteData = async (id) => {
        try {
            const deleteData = await store.dispatch('app-food/deleteSubCategoryData', id)

            toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                    title: `Success`,
                    icon: 'BellIcon',
                    variant: 'success',
                    text: `${deleteData?.data?.message}`,
                },
            });

            fetchSubCategoryData()
        } catch(error) {
            toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                    title: `Error`,
                    icon: 'BellIcon',
                    variant: 'danger',
                    text: error?.response?.data?.message || error,
                },
            });
        }
    }

    return {
        tableColumns,
        subCategoryData,
        refetchSubCategoryData,
        searchQuery,
        fetchSubCategoryData,
        sortBy,
        isSortDirDesc,
        foodSubCategories,
        totalfoodSubCategories,
        dataMeta,
        refSubCategoryListTable,
        currentPage,
        statusFilter,
        perPage,
        perPageOptions,
        resolveSubCategoryStatusVariant,
        resolveSubCategoryStatusnameVariant,
        updateSubCategory,
        isSubCategoryFormSidebarActive,
        deleteData,
    }
}